<template>
  <a :href="addToSlackUrl" class="slack-button" :target="openInNewTab ? '_blank' : undefined" :rel="openInNewTab ? 'noopener noreferrer' : undefined">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.8 122.8" class="slack-icon">
      <path d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" fill="#e01e5a"/>
      <path d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" fill="#36c5f0"/>
      <path d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0-7.1-5.8-12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" fill="#2eb67d"/>
      <path d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" fill="#ecb22e"/>
    </svg>
    Add to Slack
  </a>
</template>

<script>
export default {
  name: 'AddToSlackButton',
  props: {
    openInNewTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addToSlackUrl() {
      let installRedirectUri = process.env.VUE_APP_API_BASE_URL + "/install-callback" || "https://chat.prec8.com/install-callback";
      let slackClientId = process.env.VUE_APP_SLACK_CLIENT_ID || "5302144459057.7245506041362";
      return "https://slack.com/oauth/v2/authorize?client_id=" + slackClientId + "&scope=channels:history,channels:join,channels:read,chat:write,commands,groups:history,groups:read,im:history,im:read,im:write,links:read,mpim:history,mpim:read,reactions:read,team:read,users:read,users:read.email,users:write,app_mentions:read,emoji:read&user_scope=channels:read,channels:write,groups:read,groups:write,users:read&redirect_uri=" + installRedirectUri;
    }
  }
}
</script>

<style scoped>
.slack-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #4A154B;
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  transition: background-color 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.slack-button:hover {
  background: #611f69;
  color: white;
  text-decoration: none;
}

.slack-icon {
  width: 20px;
  height: 20px;
}
</style> 